(function () {

  'use strict';

  function pxSitesList(
    $rootScope, $timeout, SitesProviderService, SiteService, $location, $routeParams
  ) {
    return {
      restrict: 'EA',
      scope: {
        me: '=me',
        paginationObject: '=paginationObject'
      },
      templateUrl: 'app/components/sites/sitesList/sitesList.template.html',
      link: function (scope) {

        scope.loadingPage = false;
        scope.focus = false;
        scope.sitesList = [];
        let scrollEnd = null;
        let containerHeight = null;

        window.mobileAndTabletCheck = function () {
          let check = false;
          (function (a) {
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
              check = true;
            }
          })(navigator.userAgent || navigator.vendor || window.opera);
          return check;
        };

        (function () {
          init();
        })();

        function init() {
          // getSearchStringFromUrl();
          getFirstPage();
          setFocus();
        }

        function setFocus() {
          if (!window.mobileAndTabletCheck()) {
            $timeout(function () {
              scope.focus = true;
            }, 500);
          }
        }

        // function getSearchStringFromUrl() {
        //   scope.paginationObject.pagingCriteria.match = $routeParams['siteSearch'];
        // }

        function getFirstPage() {
          scope.sitesList = [];
          scope.paginationObject.pagingCriteria.page = 0;
          scope.loadingPage = true;
          SitesProviderService.getSitesPaged(scope.paginationObject)
            .then(function (response) {
              window.scrollTo(0, 0);
              angular.element('.sites-list-long').scrollTop(0);
              scope.totalPages = response.page.totalPages;
              scope.sitesList = response.sites;
              scope.loadingPage = false;
            })
            .catch(function () {
              scope.loadingPage = false;
            });
        }

        scope.commitSearch = function () {
          // Following line causes undesired page reload under certain circumstances:
          // $location.search('siteSearch', scope.paginationObject.pagingCriteria.match);
          getFirstPage();
        };

        function getNextPage() {
          if (!scope.loadingPage && scope.totalPages > scope.paginationObject.pagingCriteria.page + 1) {
            scope.paginationObject.pagingCriteria.page += 1;
            scope.loadingPage = true;
            SitesProviderService.getSitesPaged(scope.paginationObject)
              .then(function (response) {
                if (response.sites) {
                  scope.sitesList = scope.sitesList.concat(response.sites);
                }
                scope.loadingPage = false;
              })
              .catch(function () {
                scope.loadingPage = false;
              });
          }
        }

        angular.element('.sites-list-long').on('scroll', function (event) {
          scrollEnd = event.currentTarget.clientHeight + event.currentTarget.scrollTop + 1;
          containerHeight = event.currentTarget.scrollHeight;
          if (!scope.loadingPage && scope.totalPages > scope.paginationObject.pagingCriteria.page + 1) {
            if (scrollEnd > containerHeight) {
              $timeout(function () {
                getNextPage();
              }, 300);
            }
          }
        });

        scope.$on('$destroy', function () {
          angular.element('.sites-list-long').off('scroll');
        });

        scope.selectSite = function (event, site) {
          SiteService.putSiteInStorage(site);
          $rootScope.$broadcast('UPDATE_SELECTED_SITES', site);
        };

        scope.openSiteContextMenu = function (event, site) {
          scope.closeAllMenues();
          $rootScope.$broadcast('SITE_LIST_CONTEXT_CONTROL');
          scope.menuContent = {
            menuItems: [
              { title: 'SiteName',             selected: false, type: 'rename',          breaker: false, order: 6, disabled: scope.me.isSystemObserver() },
              { title: 'SiteManagerGroups',    selected: false, type: 'siteManagers',    breaker: false, order: 5, bypassCloseOutside: true },
              { title: 'Networks',             selected: false, type: 'siteNetworks',    breaker: true,  order: 4 },
              { title: 'AddSiteManagerGroups', selected: false, type: 'addSiteManagers', breaker: false, order: 3, disabled: scope.me.isSystemObserver(), bypassCloseOutside: true },
              { title: 'AddNetworks',          selected: false, type: 'addNetworks',     breaker: true,  order: 2, disabled: scope.me.isSystemObserver() },
              { title: 'DeleteSite',           selected: false, type: 'deleteSite',      breaker: false, order: 1, disabled: scope.me.isSystemObserver() }
            ],
            context: site,
            icon: 'icon-pin',
            sizeClass: 'size115',
            type: 'SITE'
          };
          scope.menuSpecs = {
            position: { left: event.clientX, top: event.clientY },
            type: 'SITE'
          };
        };

        scope.closeAllMenues = function (selectedContextMenuItem, contextContentPosition, contextContent) {
          scope.menuContent = null;
          scope.menuSpecs = null;
          scope.selectedContextMenuItem = selectedContextMenuItem;
          scope.contextContentPosition = contextContentPosition;
          scope.contextContent = contextContent;
          scope.auxiliaries = { me: scope.me };
        };

        const deregisterSiteTreeContextControlListener = $rootScope.$on('SITE_TREE_CONTEXT_CONTROL', function () {
          scope.closeAllMenues(null, null, null);
        });

        const deregisterSiteContextControlListener = $rootScope.$on('SITE_CONTEXT_CONTROL', function () {
          scope.closeAllMenues(null, null, null);
        });

        scope.$on('$destroy', function () {
          deregisterSiteTreeContextControlListener();
          deregisterSiteContextControlListener();
        });
      }
    };
  }

  pxSitesList.$inject = ['$rootScope', '$timeout', 'SitesProviderService', 'SiteService', '$location', '$routeParams'];

  angular
    .module('printix-admin')
    .directive('pxSitesList', pxSitesList);

})();
